<template>
  <div class="main-side-bar" :class="{'collapsed': collapsed}">
    <div class="link-list">
      <ul>
        <li v-if="isAdmin">
          <router-link :to="{ name: 'KegManage'}">
            <div class="link-content">
              <b-icon icon="journals"></b-icon>
              <span>酒桶管理</span>
            </div>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'kegBatchIndex'}">
            <div class="link-content">
              <b-icon icon="grid3x3-gap"></b-icon>
              <span>批次更新狀態</span>
            </div>
          </router-link>
        </li>
      </ul>
    </div>

    <div class="bottom-tool">

    </div>

    <b-button class="toggle-btn" @click="toggleBtnClicked">
      <b-icon icon="x"></b-icon>
    </b-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'MainSideBar',
  data() {
    return {
      collapsed: false,
    };
  },
  components: {
  },
  mounted() {
  },
  watch: {
  },
  computed: {
    ... mapGetters(['isMobileSideBarShow']),
    ... mapGetters('auth', ['hasToken', 'userData']),
    isAdmin() {
      return this.hasToken && this.userData.is_admin;
    },
    routeName() {
      const sp = this.$route.path.split('/');
      if (sp.length > 2) {
        return sp[2];
      }
      return '';
    },
    toggleTabText() {
      return this.collapsed? '▶': '◀';
    }
  },
  methods: {
    logout() {
      const r = confirm('確定登出嗎?');
      if (r) {
        this.$store.dispatch('auth/loggedOut');
        this.$router.push({
          name: 'Login'
        });
      }
    },
    toggleTabCollapse() {
      this.collapsed = !this.collapsed;
    },
    toggleBtnClicked() {
      this.$store.dispatch('setMobileSideBarShow', !this.isMobileSideBarShow);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
  .main-side-bar {
    position: relative;
    /*background-color: #4D4D4D;*/
    height: 100%;
    // width: 100%;

    display: flex;
    flex-direction: column;
    align-items: stretch;
    border-right: 1.5px solid #E9E9E9;
    padding: 1rem 0;
    width: 200px;
    &.collapsed {
      .variable-link {
        padding: .5rem 1rem;
      }
      .toggle-tab:hover {
        animation: rotateRightAnimation 1.5s infinite ease-out;
      }
      @keyframes rotateRightAnimation {
        0% {
          transform: rotate(0deg) translateX(0px);
        }
        50% {
          transform: rotate(-12deg) translateX(5px);
        }
        100% {
          transform: rotate(0deg) translateX(0px);
        }
      }
    }

    .link-list {
      ul {
        padding: 0;
        margin: 0;
        list-style: none;
        >li {
          padding: .5rem 0;
          position: relative;
          a {
            position: relative;
            display: block;
            padding: 0 .5rem;
            margin: 0 .25rem;
            border-left: solid 2px transparent;
            .link-content {
              display: flex;
              color: $color-primary;
              justify-content: flex-start;
              align-items: center;
              column-gap: .5rem;
              padding: .5rem;
              border-radius: .25rem;
            }

            &:hover {
              text-decoration: none;
            }

            &.router-link-active {
              border-color: $color-tertiary;
              .link-content {
                background-color: $color-background-deep-yellow;
              }
            }
          }
        }
      }
    }

    .toggle-btn {
      display: none;
    }
    @include smaller-than-medium() {
      width: 100%;
      padding-top: 3rem;

      .toggle-btn {
        display: block;
        position: absolute;
        top: .5rem;
        right: .5rem;
        padding: .25rem;
        >svg {
          margin: 0;
        }
      }
    }
  }

</style>
